import { JuloUpdateEntry } from "./types"

export const discountInKrOrNewPriceEntry: JuloUpdateEntry = {
  slug: "2026-10-06-discount-in-kr-or-new-price",
  date: "2026-10-06",
  title: "Rabatt i kronor eller som nytt pris",
  description:
    "Nu kan ni ge rabatt på tre sätt överallt där ni lägger till rabatt – på åtgärder, produkter, paket och tvättar, på hela ordern, i rabattkoder och som automatisk rabatt på paket:\n\n- % – en procentuell rabatt, som tidigare\n- kr – ett belopp som dras av, till exempel 49 kr\n- Nytt pris – skriv in vad kunden ska betala, så räknas rabatten ut åt er\n\nUnder fältet ser ni direkt vad det nya priset blir. Kunden ser rabatten som ett avdrag i kronor bredvid det ordinarie priset.",
  images: [
    {
      src: "/julo-updates/2026-10-06-discount-in-kr-or-new-price/1-nytt-pris.png",
      alt: "Rabattrutan för en åtgärd med valen %, kr och Nytt pris. Nytt pris är valt, 199 kr är ifyllt och under fältet står 110 kr rabatt på ordinarie 309 kr.",
    },
  ],
}
